import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'th.staging.jobsdb.com',
    clientId: 'MJbwjBJJt35LCNwYA2lQuWyaRPPn7lPa',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSDB,
    contactUs: {
        en: 'https://th.jobsdb.com/en-th/pages/regional-coverage/',
        th: 'https://th.jobsdb.com/th-th/pages/regional-coverage/',
    },
    siteName: siteNames.candidate.jobsdb.th,
    zone: getZoneFromSite(siteNames.candidate.jobsdb.th),
    product: Product.SEEK,
};
//# sourceMappingURL=th_staging_jobsdb_com.js.map